// @flow

// GlobalId is Base64 encoded id with some prefix like 'AggregatesListing' separated by ':'
export const getIdFromGlobalId = (id: string): string =>
  atob(id).split(':').pop();
